export const en_US_cpq = {
  CPQ: {
    "Admin.AbacPolicies.updatePolicies.name": "Update policies",
    "Admin.AbacPolicies.bulkUpdatePolicies.name": "Bulk update policies",
    "Admin.AbacCustomClaimsAttributes.claimKey": "Claim key",
    "Admin.AbacNavigation.Companies.name": "Companies",
    "Admin.AbacNavigation.Customers.name": "Customers",
    "Admin.AbacNavigation.Opportunities.name": "Opportunities",
    "Admin.AbacNavigation.Quotes.name": "Quotes",
    "Admin.AbacNavigation.Resources.name": "Resources",
    "Admin.AbacNavigation.SalesLocations.name": "Sales Locations",
    "Admin.AbacPoliciesBulkUpdate.save": "Save",
    "Admin.AbacPoliciesBulkUpdate.cancel": "Cancel",
    "Admin.AbacPoliciesBulkUpdate.error": "Error saving policies",
    "Admin.AbacPoliciesForm.addButton": "Add",
    "Admin.AbacPoliciesForm.attributeKey.helperText":
      "The attribute that grants access",
    "Admin.AbacPoliciesForm.attributeKey.label": "Attribute key",
    "Admin.AbacPoliciesForm.attributeValue.helperText":
      "The value that grants access",
    "Admin.AbacPoliciesForm.attributeValue.label": "Attribute value",
    "Admin.AbacPoliciesForm.scope.helperText": "Scope of the policy",
    "Admin.AbacPoliciesForm.scope.label": "Scope",
    "Admin.AbacPoliciesForm.userAttributeKey.label": "User attribute key",
    "Admin.AbacPoliciesTable.attributeKey": "Attribute",
    "Admin.AbacPoliciesTable.attributeValue": "Value",
    "Admin.AbacPoliciesTable.delete": "Delete",
    "Admin.AbacPoliciesTable.scope": "Scope",
    "Admin.AbacPoliciesUpdate.error": "Error saving policies",
    "Admin.AbacUserAttributes.attributeKey": "Attribute Key",
    "Admin.AbacUserAttributes.userName": "User Name",
    "Admin.AddDefaultPoliciesDialog.apply": "Apply",
    "Admin.AddDefaultPoliciesDialog.cancel": "Cancel",
    "Admin.AddDefaultPoliciesDialog.title": "Add default policies",
    "Admin.Common.Columns.country.name": "Country",
    "Admin.Common.Columns.contactFirstName.name": "Contact First Name",
    "Admin.Common.Columns.contactLastName.name": "Contact Last Name",
    "Admin.Common.Columns.createdByName.name": "Created by",
    "Admin.Common.Columns.createdOn.name": "Created on",
    "Admin.Common.Columns.identifier.name": "Identifier",
    "Admin.Common.Columns.lastUpdatedByName.name": "Updated by",
    "Admin.Common.Columns.lastUpdatedOn.name": "Updated on",
    "Admin.Common.Columns.name.name": "Name",
    "Admin.Companies.PageHeading.text": "Companies",
    "Admin.Customers.PageHeading.text": "Customers",
    "Admin.Opportunities.PageHeading.text": "Opportunities",
    "Admin.Quotes.PageHeading.text": "Quotes",
    "Admin.Resources.name": "Name",
    "Admin.RestoreDefaultPoliciesDialog.cancel": "Cancel",
    "Admin.RestoreDefaultPoliciesDialog.restore": "Restore",
    "Admin.SalesLocations.PageHeading.text": "Sales Locations",
    "Admin.AbacResourceAbacPoliciesDialog.close": "Close",
    "Admin.AbacResourcePolicyTemplatesDialog.close": "Close",
    "Admin.AbacUserPolicyTemplatesDialog.close": "Close",

    "importRelease.loading": "Importing release...",
    "importRelease.button.goToHome": "Back to Home",
    "importRelease.error": "An error occurred during import",
    "importRelease.success": "Import run successfully",
    "importRelease.redirecting":
      "You will be redirected in {{countdown}} seconds",
    "opportunity.title": "Opportunity",
    "opportunity.heading": "Opportunity {{name}} {{id}}",
    "quotes.title": "Quotes",
    "cart.title": "Cart",
    "savedCarts.title": "Saved carts",
    "inquiries.title": "Inquiries",
    "quote.label.isActive": "Active",
    "button.addQuote": "Add quote",
    "button.addLineItem": "New line item",
    "dialog.addLineItem.title": "New line item",
    "button.presets": "Presets",
    "button.gotToSavedCarts": "Saved carts",
    "button.upload": "Upload",
    "button.archive": "Archiv",
    "button.createOpportunity": "Create opportunity",
    "button.cancel": "Cancel",
    "button.save": "Ok",
    "button.reset": "Reset",
    "button.confirm": "Ok",
    "button.goToCatalog": "Go to catalog",
    "button.goToInquiries": "Inquiries",
    "button.goToQuotes": "Quotes",
    "button.inventoryDocumentation": "Inventory documentation",
    "button.download": "Download",
    "button.start": "Start",
    "button.login": "Log in",
    "button.logout": "Logout",
    "button.addCustomProduct": "Custom product",
    "button.addProduct": "Product",
    "button.addFilter": "Add filter",
    "button.delete": "Delete",
    "select.language": "Language",
    "dialog.createOpportunity.subtitle": "",
    "dialog.updateOpportunity.title": "Edit opportunity",
    "dialog.updateOpportunity.subtitle": "",
    "button.footer.backToOverview": "Back to overview",
    "button.footer.saveAndExit": "Save and exit",
    "footer.status.title": "Status",
    "button.footer.setStatusManually": "Set status manually",
    "button.footer.generateDocument": "Generate document",
    "button.preview": "Preview",
    "dialog.previewInquiry.title": "Preview inquiry",
    "button.footer.backToConfiguration": "Back to configuration",
    "button.addConfigurableProduct": "Add configurable product",
    "buttons.addConfigurationToItemGroupsButtonSelect.label": "Add to quote",

    "button.unarchiveOpportunity": "restore",
    "button.archiveOpportunity": "archive",

    "button.addItemGroup": "New group",
    "button.updateItemGroup": "Edit",
    "dialog.createCustomer.title": "Create customer",
    "dialog.createCustomer.subtitle": "",
    "dialog.createCompany.title": "Create company",
    "dialog.createCompany.subtitle": "",
    "dialog.addLineItem.input.label.lineItemName": "Line item name",
    "dialog.createOpportunity.input.label.opportunityName": "Name",
    "dialog.createOpportunity.input.label.customer": "Customer",
    "dialog.createOpportunity.input.label.zipCode": "Zip code",
    "dialog.createOpportunity.input.label.city": "City",
    "dialog.createOpportunity.input.label.description": "Description",
    "dialog.createOpportunity.title": "New Opportunity",
    "dialog.createOpportunity.input.validFrom.label": "Valid from",
    "dialog.createOpportunity.input.validTo.label": "Valid to",
    "dialog.configuratorMode.title": "Create new quote",
    "dialog.configuratorMode.option.configurator.title": "Configuration",
    "dialog.configuratorMode.option.configurator.description":
      "Overall system configuration",
    "dialog.configuratorMode.option.expressMode.title": "Express Mode",
    "dialog.configuratorMode.option.expressMode.description":
      "Single item order",
    "dialog.configuratorMode.description": "Choose your preferred mode",
    "dialog.confirm.unarchiveQuote.title": "Restore quote",
    "dialog.confirm.unarchiveQuote.description":
      "Do you really want to restore this quote?",
    "dialog.confirm.archiveQuote.title": "Archive quote",
    "dialog.confirm.archiveQuote.description":
      "Do you really want to archive this quote?",
    "dialog.confirm.unarchiveOpportunity.title": "Restore opportunity",
    "dialog.confirm.unarchiveOpportunity.description":
      "Do you really want to restore this opportunity?",
    "dialog.confirm.archiveOpportunity.title": "Archive opportunity",
    "dialog.confirm.archiveOpportunity.description":
      "Do you really want to archive this opportunity?",

    "dialog.confirm.setOptional.title": "Set optional",
    "dialog.confirm.unsetOptional.title": "Unset optional",
    "dialog.confirm.setOptional.subtitle": "",
    "dialog.confirm.unsetOptional.subtitle": "",
    "dialog.confirm.setOptional.content":
      "Do you really want to set this item as optional?",
    "dialog.confirm.unsetOptional.content":
      "Do you really want to unset this item as optional?",

    "dialog.confirm.genericDelete.title": "Delete",
    "dialog.confirm.genericDelete.content":
      "Do you really want to delete this item?",

    "dialog.addProducts.title.addProduct": "Select products",

    "dialog.addItemGroup.title": "New group",
    "dialog.addItemGroup.input.label.itemGroupName": "Group name",

    "dialog.updateItemGroup.title": "Edit group",
    "dialog.updateItemGroup.input.label.itemGroupName": "Group name",

    "dialog.updateLineItem.title": "Edit line item",
    "dialog.updateLineItem.input.label.itemGroupName": "Line item name",

    "dialog.updateDefault.title": "Edit",
    "dialog.updateDefault.input.label.name": "Name",

    "dialog.addCustomProduct.title": "Add custom product",
    "dialog.editCustomProduct.title": "Edit custom product",
    "dialog.addCustomProduct.identifier": "Identifier",
    "dialog.addCustomProduct.partId": "Article number",
    "dialog.addCustomProduct.name": "Name",
    "dialog.addCustomProduct.description": "Description",
    "dialog.addCustomProduct.customer": "Customer",
    "dialog.addCustomProduct.productTypeId": "Product Type",
    "dialog.addCustomProduct.productStateId": "Product State",
    "dialog.addCustomProduct.isShared": "Shared product",
    "dialog.addCustomProduct.isActive": "Active",

    "breadcrumb.opportunities": "Opportunities",
    "breadcrumb.opportunity": "Opportunity",
    "breadcrumb.quotes": "Quotes",
    "breadcrumb.presets": "Presets",
    "breadcrumb.catalog": "Catalog",
    "breadcrumb.documentGeneration": "Document Generation",
    "breadcrumb.quoteInfo": "Quote Info",
    "breadcrumb.salesQuotationView": "Sales Quotation View",
    "breadcrumb.quote": "Quote",
    "breadcrumb.savedCarts": "Saved Carts",
    "breadcrumb.inquiries": "Inquiries",
    "breadcrumb.cart": "Cart",
    "breadcrumb.configurator": "Configurator",

    "subnavigation.catalog": "Catalog",
    "subnavigation.salesQuotationView": "Sales quotation view",
    "subnavigation.documentGeneration": "Document Generation",
    "subnavigation.quoteInfo": "Quote Info",

    "header.opportunity": "Opportunity",
    "header.opportunities": "Opportunities",
    "header.quoteDetails": "Quote",
    "header.itemGroupDetails": "Item Group",
    "header.archive": "Archive",
    "header.configurator": "Configurator",
    "header.expressMode": "Express mode",
    "header.lineItemDetails": "Line item",
    "header.presets": "Presets",
    "header.catalog": "Catalog",

    "dropZone.label": "Drag & drop or browse",
    "dropZone.isDragActive.label": "Drop here",
    "fileUpload.label": "Upload file",
    "requestQuote.fileUpload.label": "Attachments",
    "filters.input.label.identifier": "Name",
    "filters.input.label.zipCode": "Zip code",
    "filters.input.label.city": "City",
    "filters.input.label.customer": "Customer",
    "filters.input.label.status": "Status",
    "filters.input.label.search": "Search",

    "quote.property.label.uniqueNumberString": "Quote number",
    "quote.property.label.name": "Name",
    "quote.property.label.description": "Description",
    "quote.property.label.region": "Region",
    "quote.property.label.revision": "Revision number",
    "quote.property.label.createdBy": "Created by",
    "quote.property.label.customer": "Customer",
    "quote.property.label.lastUpdatedOn": "Last updated on",
    "quote.property.label.lastUpdatedBy": "Last updated by",
    "quote.property.label.status": "Status",

    "accordion.itemGroup.title": "Group",
    "itemGroup.name": "Group Name",

    "table.actions.deleteRow": "Delete",

    "table.savedCarts.header.quoteNumber": "Cart number",
    "table.savedCarts.header.name": "Name",
    "table.savedCarts.header.description": "Description",
    "table.savedCarts.header.createdOn": "Created on",
    "table.savedCarts.header.lastUpdatedOn": "Last updated on",
    "table.savedCarts.header.totalNet": "Total net",

    "table.inquiries.header.inquiryNumber": "Inquiry number",
    "table.inquiries.header.name": "Name",
    "table.inquiries.header.lastUpdatedOn": "Updated on",
    "table.inquiries.header.createdOn": "Created on",
    "table.inquiries.header.totalNet": "Total net",

    "table.lineItems.header.articleNumber": "Article number",
    "table.lineItems.header.partId": "Part ID",
    "table.lineItems.header.name": "Name",
    "table.lineItems.header.identifier": "Identifier",
    "table.lineItems.header.productIdentifier": "Product identifier",
    "table.lineItems.header.description": "Description",
    "table.lineItems.header.quantity": "Quantity",
    "table.lineItems.header.actions": "Actions",
    "table.lineItems.header.optional": "Optional",
    "table.lineItems.header.company": "Company",

    "table.lineItems.actions.cloneRow": "Duplicate",
    "table.lineItems.actions.deleteRow": "Delete",
    "table.lineItems.actions.showBOM": "Show BOM",
    "table.lineItems.actions.showSummary": "Show Summary",
    "catalog.productTable.header.favorit": "Favorit",
    "catalog.productTable.header.preview": "Preview",
    "catalog.productTable.header.articleNumber": "Article number",
    "catalog.productTable.header.name": "Name",
    "catalog.productTable.header.description": "Description",
    "catalog.productTable.header.cost": "Cost",
    "catalog.productTable.header.totalCost": "Total cost",
    "catalog.productTable.header.listPrice": "List price",
    "catalog.productTable.header.actions": "Quantity",
    "catalog.productTable.header.createdByName": "Created by",
    "catalog.productTable.header.createdOn": "Created On",
    "catalog.productTable.header.lastUpdatedOn": "Last updated on",
    "catalog.productTable.header.lastUpdatedByName": "Last updated by",
    "catalog.productTable.buttons.addProductToGroup": "Add",
    "catalog.productTable.buttons.addAllProductsToGroup": "Add all",
    "catalog.productTable.menu.addLineItemToNewGroup": "Create new group",
    "catalog.buttons.showLineItems": "Show line items",
    "catalog.buttons.columnsSelection": "Columns",
    "buttons.toggleSideView.label": "Sideview",
    "product.types.tooltip.Configurable": "Configurable",
    "product.types.tooltip.NonConfigurable": "Non configurable",
    "product.types.tooltip.PreConfigurable": "Preconfigured",
    "product.types.tooltip.configurationStatus.toConfigure": "To be configured",
    "product.types.tooltip.configurationStatus.complete":
      "Configuration is complete",
    "product.types.tooltip.configurationStatus.incomplete":
      "Configuration is incomplete",

    "product.status.text.toConfigure": "Configure",
    "product.status.text.complete": "Configured",
    "product.status.text.incomplete": "Edit",

    "productsTable.tree.filter": "Filter",
    "productsTable.tree.categoriesToggleText": "Categories",

    "productsTable.SharedProducts.title": "Shared Products",
    "productsTable.CustomProducts.title": "Custom Products",

    "relatedProducts.title": "Related products",
    "relatedProducts.noProducts": "No products",
    "alternativeProducts.title": "Alternative products",

    "table.itemGroups.title": "Project",
    "table.itemGroups.header.rank": "Rank",
    "table.itemGroups.header.moveRow": "Move row",
    "table.itemGroups.header.name": "Name",
    "table.itemGroups.header.description": "Description",
    "table.itemGroups.header.partId": "Part ID",
    "table.itemGroups.header.managingEntity": "Managing entity (ME)",
    "table.itemGroups.header.priceList": "Price list",
    "table.itemGroups.header.supportingEntity": "Supporting entity (SE)",
    "table.itemGroups.header.qty": "Quantity",
    "table.itemGroups.header.itemCost": "Item cost",
    "table.itemGroups.header.costListPricing": "Cost+/List-pricing",
    "table.itemGroups.header.markup": "Markup",
    "table.itemGroups.header.Markup1Percentage": "Markup 1 (%)",
    "table.itemGroups.header.Markup2Percentage": "Markup 2 (%)",
    "table.itemGroups.header.itemList": "Item list",
    "table.itemGroups.header.totalList": "Total List",
    "table.itemGroups.header.discount1": "Discount 1",
    "table.itemGroups.header.discount2": "Discount 2",
    "table.itemGroups.header.discount3": "Discount 3",
    "table.itemGroups.header.discount4": "Discount 4",
    "table.itemGroups.header.totalDiscount": "Total discount",

    "table.itemGroups.input.label.Markup1": "Markup 1",
    "table.itemGroups.input.label.Markup2": "Markup 2",
    "table.itemGroups.input.label.Discount1": "Discount 1",
    "table.itemGroups.input.label.Discount2": "Discount 2",
    "table.itemGroups.input.label.Discount3": "Discount 3",
    "table.itemGroups.input.label.Discount4": "Discount 4",

    "table.itemGroups.input.label.Markup1Percentage": "Markup 1(%)",
    "table.itemGroups.input.label.Markup2Percentage": "Markup 2 (%)",
    "table.itemGroups.input.label.Discount1Percentage": "Discount 1 (%)",
    "table.itemGroups.input.label.Discount2Percentage": "Discount 2 (%)",
    "table.itemGroups.input.label.Discount3Percentage": "Discount 3 (%)",
    "table.itemGroups.input.label.Discount4Percentage": "Discount 4 (%)",

    "table.itemGroups.header.discount1Percentage": "Discount 1 (%)",
    "table.itemGroups.header.discount2Percentage": "Discount 2 (%)",
    "table.itemGroups.header.discount3Percentage": "Discount 3 (%)",
    "table.itemGroups.header.discount4Percentage": "Discount 4 (%)",
    "table.itemGroups.header.totalDiscountPercentage": "Total discount (%)",
    "table.itemGroups.header.totalNet": "Total Net",
    "table.itemGroups.header.margin": "Gross Margin",
    "table.itemGroups.header.cost": "Cost",
    "table.itemGroups.header.actions": "Actions",
    "table.itemGroups.header.totalCost": "Total cost",
    "table.itemGroups.header.listPrice": "List price",
    "table.itemGroups.header.cfgName": "CFG name",
    "table.itemGroups.header.cfgDescription": "CFG description",
    "table.itemGroups.header.cfgTypecode": "CFG type code",
    "table.itemGroups.header.customerPosition": "CustomerPosition",
    "table.itemGroupsOptional.title": "Optional",

    "categories.sharedProducts": "Shared products",
    "categories.customProducts": "Custom products",

    "catalog.productTable.buttons.addProductToLineItem": "Add to Line Item",
    "catalog.productTable.buttons.addAllProductsToLineItem":
      "Add all to Line Item",
    "catalog.productTable.buttons.addProductsToQuote": "Add to Quote",
    "catalog.productTable.buttons.addAllProductsToQuote": "Add all to Quote",
    "quote.buttons.exportToExcel": "Export",
    "catalog.selectACategoryFirst": "Select a category first",
    "button.import": "Import",
    "dialog.importExcel.title": "Import Excel",
    "dialog.createQuote.title": "Create quote",
    "dialog.createQuote.subtitle": "",
    "dialog.createQuote.input.label.name": "Name",
    "dialog.createQuote.input.label.description": "Description",
    "dialog.createQuote.input.label.region": "Region",
    "dialog.createQuote.input.label.customer": "Customer",
    "dialog.cloneQuote.title": "Clone quote",
    "dialog.cloneQuote.subtitle": "Clone existing quote",
    "dialog.cloneCart.title": "Clone cart",
    "dialog.cloneCart.subtitle": "Clone existing cart",
    "dialog.updateQuote.title": "Edit quote",
    "dialog.updateQuote.subtitle": "",
    "dialog.updateCart.title": "Edit cart",
    "dialog.updateCart.subtitle": "",
    "button.uploadGeneric.placeholder": "Upload file",
    "checkbox.import.label.override": "Check here to override existing entries",
    priceListSelectLabel: "Price list",
    currencySelectLabel: "Currency",
    "button.goBackToOpportunities": "Back to opportunities",
    "button.goBackToOpportunity": "Back to opportunity",
    "button.goBackToQuote": "Back to quote",
    "button.createQuote": "Create quote",
    "item.property.label.customerPosition": "CustomerPosition",
    "item.property.label.listPrice": "List price",
    "item.property.label.totalList": "Total list price",
    "item.property.label.discount": "Discount",
    "item.property.label.totalDiscount": "Total discount",
    "item.property.label.totalCost": "Total cost",
    "item.property.label.totalNet": "Total net price",
    "item.property.label.status": "Status",
    "item.property.label.name": "Name",
    "item.property.label.partId": "Article number",
    "item.property.label.description": "Description",
    "item.property.label.quantity": "Quantity",
    "subItem.property.label.totalList": "List",
    "subItem.property.label.totalCost": "Cost",
    "subItem.property.label.totalNet": "Net",
    "lineItems.bom.label": "Bill of materials",
    "priceSummary.totalCost": "Total cost",
    "priceSummary.totalList": "Total list",
    "priceSummary.totalNet": "Total net",

    "dialog.requestQuote.title": "Send request",
    "dialog.saveCart.title": "Save cart",
    "dialog.saveCart.subtitle":
      "Your current cart will be saved for later. A new empty cart will be created and set as your active cart.",

    "select.topBottom.option.label.top": "List",
    "select.topBottom.option.label.bottom": "Cost+",

    "priceList.select.confirm.title": "Do you want to proceed?",
    "priceList.select.confirm.subtitle": "",
    "priceList.select.confirm.content":
      "Changing the price list at this level will overwrite all price lists at lower levels.",

    "savedCarts.setActive.confirm.title": "Please confirm",
    "savedCarts.setActive.confirm.subtitle":
      "Do you really want to change the active cart?",
    "savedCarts.setActive.confirm.content":
      "Do you want to proceed with the original or create a copy?",

    "dialog.savedCarts.continueWithOriginal": "Original",
    "dialog.savedCarts.continueWithCopy": "Copy",

    "toast.error.unknown": "An error occurred",
    "toast.error.cartRequestFailed": "Failed to send your request",

    "priceTag.label.list": "List",
    "priceTag.label.cost": "Cost",
    "toast.success.itemWasAddedToQuote": "Item was added to quote",
    "toast.success.groupCreated": "The group was created",
    "toast.success.groupWithItemsCreated":
      "The group was created and Items were added",
    "toast.success.itemWasAddedToCart": "Item was added to the cart",
    "toast.success.cartRequestSuccessful": "Your request has been sent",

    "form.field.label.customerNumber": "Customer Number",
    "form.field.label.companyName": "Company Name",
    "form.field.label.company": "Company",
    "form.field.label.name": "Name",
    "form.field.label.contactSalutation": "Salutation",
    "form.field.label.contactTitle": "Title",
    "form.field.label.contactFirstName": "Name",
    "form.field.label.contactLastName": "Last Name",
    "form.field.label.street": "Street",
    "form.field.label.streetNumber": "Number",
    "form.field.label.postalCode": "Postal Code",
    "form.field.label.town": "Town",
    "form.field.label.country": "Country",
    "form.field.label.emailAddress": "Email",
    "form.field.label.phoneNumber": "Phone",
    "form.field.label.mobileNumber": "Mobile",
    "form.field.label.companyId": "Company",
    "form.field.label.description": "Description",
    "form.field.error.email": "Email address is not valid",

    "form.field.label.lastName": "Last Name",
    "form.field.label.number": "Number",
    "form.field.label.phone": "Phone",
    "form.field.label.mobile": "Mobile",
    "form.field.label.eMail": "Email",

    // BasicCustomerForm
    "form.BasicCustomerForm.field.label.customerNumber": "Customer Number",
    "form.BasicCustomerForm.field.label.contactSalutation": "Salutation",
    "form.BasicCustomerForm.field.label.contactTitle": "Title",
    "form.BasicCustomerForm.field.label.contactFirstName": "Name",
    "form.BasicCustomerForm.field.label.contactLastName": "Last Name",
    "form.BasicCustomerForm.field.label.street": "Street",
    "form.BasicCustomerForm.field.label.streetNumber": "Number",
    "form.BasicCustomerForm.field.label.postalCode": "Postal Code",
    "form.BasicCustomerForm.field.label.town": "Town",
    "form.BasicCustomerForm.field.label.country": "Country",
    "form.BasicCustomerForm.field.label.emailAddress": "Email",
    "form.BasicCustomerForm.field.label.phoneNumber": "Phone",
    "form.BasicCustomerForm.field.label.mobileNumber": "Mobile",

    // CustomerFormWithCompanySelect
    "form.CustomerFormWithCompanySelect.field.label.customerNumber":
      "Customer Number",
    "form.CustomerFormWithCompanySelect.field.label.contactSalutation":
      "Salutation",
    "form.CustomerFormWithCompanySelect.field.label.contactTitle": "Title",
    "form.CustomerFormWithCompanySelect.field.label.contactFirstName": "Name",
    "form.CustomerFormWithCompanySelect.field.label.contactLastName":
      "Last Name",
    "form.CustomerFormWithCompanySelect.field.label.street": "Street",
    "form.CustomerFormWithCompanySelect.field.label.streetNumber": "Number",
    "form.CustomerFormWithCompanySelect.field.label.postalCode": "Postal Code",
    "form.CustomerFormWithCompanySelect.field.label.town": "Town",
    "form.CustomerFormWithCompanySelect.field.label.country": "Country",
    "form.CustomerFormWithCompanySelect.field.label.emailAddress": "Email",
    "form.CustomerFormWithCompanySelect.field.label.phoneNumber": "Phone",
    "form.CustomerFormWithCompanySelect.field.label.mobileNumber": "Mobile",

    // CustomerFormWithCompanyInput
    "form.CustomerFormWithCompanyInput.field.label.customerNumber":
      "Customer Number",
    "form.CustomerFormWithCompanyInput.field.label.companyId": "Company",
    "form.CustomerFormWithCompanyInput.field.label.contactSalutation":
      "Salutation",
    "form.CustomerFormWithCompanyInput.field.label.contactTitle": "Title",
    "form.CustomerFormWithCompanyInput.field.label.contactFirstName": "Name",
    "form.CustomerFormWithCompanyInput.field.label.contactLastName":
      "Last Name",
    "form.CustomerFormWithCompanyInput.field.label.street": "Street",
    "form.CustomerFormWithCompanyInput.field.label.streetNumber": "Number",
    "form.CustomerFormWithCompanyInput.field.label.postalCode": "Postal Code",
    "form.CustomerFormWithCompanyInput.field.label.town": "Town",
    "form.CustomerFormWithCompanyInput.field.label.country": "Country",
    "form.CustomerFormWithCompanyInput.field.label.emailAddress": "Email",
    "form.CustomerFormWithCompanyInput.field.label.phoneNumber": "Phone",
    "form.CustomerFormWithCompanyInput.field.label.mobileNumber": "Mobile",

    // CompanyForm
    "form.CompanyForm.field.label.name": "Name",
    "form.CompanyForm.field.label.country": "Country",

    // SalesLocationForm
    "form.SalesLocationForm.field.label.contactSalutation": "Salutation",
    "form.SalesLocationForm.field.label.contactTitle": "Title",
    "form.SalesLocationForm.field.label.contactFirstName": "Name",
    "form.SalesLocationForm.field.label.contactLastName": "Last Name",
    "form.SalesLocationForm.field.label.street": "Street",
    "form.SalesLocationForm.field.label.streetNumber": "Number",
    "form.SalesLocationForm.field.label.postalCode": "Postal Code",
    "form.SalesLocationForm.field.label.town": "Town",
    "form.SalesLocationForm.field.label.country": "Country",
    "form.SalesLocationForm.field.label.emailAddress": "Email",
    "form.SalesLocationForm.field.label.phoneNumber": "Phone",
    "form.SalesLocationForm.field.label.mobileNumber": "Mobile",

    // SendEmailForm
    "form.SendEmailForm.field.label.customerNumber": "Customer Number",
    "form.SendEmailForm.field.label.company": "Company",
    "form.SendEmailForm.field.label.name": "Name",
    "form.SendEmailForm.field.label.lastName": "Last Name",
    "form.SendEmailForm.field.label.street": "Street",
    "form.SendEmailForm.field.label.number": "Number",
    "form.SendEmailForm.field.label.postalCode": "Postal Code",
    "form.SendEmailForm.field.label.town": "Town",
    "form.SendEmailForm.field.label.country": "Country",
    "form.SendEmailForm.field.label.eMail": "Email",
    "form.SendEmailForm.field.label.phone": "Phone",
    "form.SendEmailForm.field.label.mobile": "Mobile",
    "form.SendEmailForm.field.label.description": "Description",

    // RequestQuoteForm
    "form.RequestQuoteForm.field.label.customerNumber": "Customer Number",
    "form.RequestQuoteForm.field.label.companyName": "Company Name",
    "form.RequestQuoteForm.field.label.contactSalutation": "Salutation",
    "form.RequestQuoteForm.field.label.contactTitle": "Title",
    "form.RequestQuoteForm.field.label.contactFirstName": "Name",
    "form.RequestQuoteForm.field.label.contactLastName": "Last Name",
    "form.RequestQuoteForm.field.label.street": "Street",
    "form.RequestQuoteForm.field.label.streetNumber": "Number",
    "form.RequestQuoteForm.field.label.postalCode": "Postal Code",
    "form.RequestQuoteForm.field.label.town": "Town",
    "form.RequestQuoteForm.field.label.country": "Country",
    "form.RequestQuoteForm.field.label.emailAddress": "Email",
    "form.RequestQuoteForm.field.label.phoneNumber": "Phone",
    "form.RequestQuoteForm.field.label.mobileNumber": "Mobile",
    "form.RequestQuoteForm.field.label.description": "Description",

    // TermsAndConditionsForm
    "form.TermsAndConditionsForm.field.label.TextReference": "Text reference",
    "form.TermsAndConditionsForm.field.label.Signature": "Signature",
    "form.TermsAndConditionsForm.field.label.IncoTerms": "Incoterms",
    "form.TermsAndConditionsForm.field.label.PaymentTerms": "Payment terms",
    "form.TermsAndConditionsForm.field.label.ShippingMethod": "Shipping method",

    // SaveCartForm
    "form.SaveCartDialogForm.field.label.name": "Name",
    "form.SaveCartDialogForm.field.label.description": "Description",

    "quoteInfo.buttons.addNewCustomer": "Add new customer",
    "quoteInfo.buttons.addNewCompany": "Add new company",
    "quoteInfo.buttons.addNewSalesLocation": "Add new sales",
    "quoteInfo.buttons.assignSalesLocation": "Assign",
    "quoteInfo.buttons.assignCustomer": "Assign customer",
    "quoteInfo.buttons.save": "Assign customer",

    "quoteInfo.general.header": "General information",
    "quoteInfo.general.quoteId": "Quote id",
    "quoteInfo.general.quote.uniqueNumberString": "Quote number",
    "quoteInfo.general.opportunity.uniqueNumberString": "Opportunity number",
    "quoteInfo.general.currency": "Currency",
    "quoteInfo.general.createdByName": "Created by",
    "quoteInfo.general.quoteCreationDate": "Quote creation date",
    "quoteInfo.general.lastUpdatedByName": "Last updated by",
    "quoteInfo.general.lastUpdatedOn": "Last updated on",
    "quoteInfo.salesLocation.header": "Sales",
    "quoteInfo.customer.header": "Customer",
    "quoteInfo.customer.customerNumber": "Customer number",
    "quoteInfo.customer.companyName": "Company name",
    "quoteInfo.customer.contactSalutation": "Salutation",
    "quoteInfo.customer.contactFirstName": "First name",
    "quoteInfo.customer.contactLastName": "Last name",
    "quoteInfo.customer.contactTitle": "Title",
    "quoteInfo.customer.street": "Street",
    "quoteInfo.customer.streetNumber": "Street number",
    "quoteInfo.customer.postalCode": "Postal code",
    "quoteInfo.customer.town": "Town",
    "quoteInfo.customer.country": "Country",
    "quoteInfo.customer.emailAddress": "Email",
    "quoteInfo.customer.phoneNumber": "Phone number",
    "quoteInfo.customer.mobileNumber": "Mobile number",
    "dialog.createSalesLocation.title": "Create sales location",
    "dialog.createSalesLocation.subtitle": "",
    "quoteInfo.customer.salesLocations.header": "Sales",
    "quoteInfo.customer.salesLocations.salesLocationName":
      "Sales locations name",
    "quoteInfo.customer.salesLocations.contactTitle": "Title",
    "quoteInfo.customer.salesLocations.contactSalutation": "Salutation",
    "quoteInfo.customer.salesLocations.contactFirstName": "First name",
    "quoteInfo.customer.salesLocations.contactLastName": "Last name",
    "quoteInfo.customer.salesLocations.street": "Street",
    "quoteInfo.customer.salesLocations.streetNumber": "Street number",
    "quoteInfo.customer.salesLocations.postalCode": "Postal code",
    "quoteInfo.customer.salesLocations.town": "Town",
    "quoteInfo.customer.salesLocations.country": "Country",
    "quoteInfo.customer.salesLocations.emailAddress": "Email",
    "quoteInfo.customer.salesLocations.phoneNumber": "Phone number",
    "quoteInfo.customer.salesLocations.mobileNumber": "Mobile number",

    "dialog.addCustomProduct.priceCost.value": "Value",
    "dialog.addCustomProduct.priceCost.validFrom": "Valid from",
    "dialog.addCustomProduct.priceCost.validTo": "Valid to",
    "dialog.addCustomProduct.price": "Price",
    "dialog.addCustomProduct.cost": "Cost",

    "productDetails.partId": "Article number",
    "productDetails.listPrice": "List price",
    "productDetails.cost": "Cost",

    "searchField.label": "Search",
    "SERVER_ERROR.DISCOUNT_EXCEEDS_LIMIT": "Discount exceeds limit",
    "SERVER_ERROR.PRODUCT_IS_IN_USE": "Product is in use and cannot be deleted",
    "filter.filterAttributeInput.label": "Attribute",
    "filter.filterOperatorInput.label": "Operator",
    "filter.filterValueInput.label": "Value",
    "filter.button.applyFilter": "Apply",
    "filter.button.clearAllFilter": "Clear all",
    "toast.error.filterAlreadyPresent": "Filter already present",
    "selectionBanner.text": "{{selectedProducts}} products selected",
    "selectionBanner.clearSelection.text": "clear selection",

    "cart.label.emptyCart": "Your cart is empty",
    "cart.button.addConfiguration": "Add configuration",
    "cart.button.addArticle": "Add article",
    "cart.button.saveShoppingCart": "Save shopping cart",
    "cart.button.printShoppingCart": "Print shopping cart",
    "cart.button.import": "Import",
    "cart.button.export": "Export",

    "cart.summary.subtotal.label": "Subtotal",
    "cart.summary.totalNet.label": "Total net",
    "cart.summary.button.requestQuote": "Request Quote",
    "cart.summary.button.proceedToCheckout": "Proceed to Checkout",

    "opportunities.table.uniqueNumberString": "Number",
    "opportunities.table.name": "Name",
    "opportunities.table.description": "Description",
    "opportunities.table.lastUpdatedOn": "Last updated",
    "opportunities.table.creationDate": "Creation date",
    "opportunities.table.status": "Status",
    "opportunities.table.toolbar.search": "Search",

    "quotes.table.uniqueNumberString": "Number",
    "quotes.table.name": "Name",
    "quotes.table.description": "Description",
    "quotes.table.lastUpdatedOn": "Last updated",
    "quotes.table.creationDate": "Creation date",
    "quotes.table.status": "Status",
    "quotes.table.toolbar.search": "Search",

    "infotext.userNotLoggedIn": "Not logged in",
    "buttons.save": "Save",
    "buttons.reset": "Reset",
    "buttons.send": "Send",
    "quotes.table.toolbar.filters.status": "Status",
    "iconButton.download": "Download",
    "iconButton.clone": "Duplicate",
    "iconButton.delete": "Delete",
    "iconButton.showBOM": "BOM",
    "iconButton.showSummary": "Summary",
    "iconButton.edit": "Edit",

    "drawer.showBOM.title": "Bill of materials",
    "drawer.showSummary.title": "Summary",

    "moveRowMenu.options.topPosition": "Top position",

    "opportunities.quotesTable.header.name": "Name",
    "opportunities.quotesTable.header.description": "Description",
    "opportunities.quotesTable.header.customer": "Customer",
    "opportunities.quotesTable.header.quoteNumber": "Quote number",
    "opportunities.quotesTable.header.createdByName": "Created by",
    "opportunities.quotesTable.header.lastUpdatedByName": "Last updated by",
    "opportunities.quotesTable.header.lastUpdatedOn": "Last updated on",
    "opportunities.quotesTable.header.status": "Status",

    "outputOptionsSelection.checkbox.includeLongText.label":
      "Includes Long Text",
    "outputOptionsSelection.checkbox.includePartId.label":
      "Includes Part Number of Articles",
    "outputOptionsSelection.checkbox.includePrices.label": "Includes Prices",
    "outputOptionsSelection.checkbox.includeDiscounts.label":
      "Includes Discounts",
    "modeToggle.switchToInternalMode": "Internal view",
    "modeToggle.switchToCustomerMode": "Customer view",

    "docGen.sendEmail.action": "Send Email",
    "docGen.sendEmail.title": "Send Email",

    "sections.termsAndConditions": "Terms & Conditions",
    "sections.deliveryInformation": "Delivery Information",
    "sections.tradeTerms": "Trade Terms",

    "validation.maxLength512": "Maximum length is {{characters}} characters.",
    "validation.integer": "Please enter an integer",

    "salesTerms.period.days": "Days",
    "salesTerms.period.weeks": "Weeks",
    "salesTerms.period.months": "Months",

    "form.field.label.TextReference": "Text reference",
    "form.field.label.Signature": "Signature",
    "form.field.label.IncoTerms": "Incoterms",
    "form.field.label.PaymentTerms": "Payment terms",
    "form.field.label.ShippingMethod": "Shipping method",
    "form.field.label.DeliveryPeriod": "Delivery period",
    "form.field.label.DeliveryPeriodInUnit": "Unit",
    "form.field.label.DeliveryDate": "Date of delivery",
    "form.field.label.TradeTerms": "Trade terms",

    "select.tradeTerms.option.OfferCustomerEU": "Offer Customer EU",
    "select.tradeTerms.option.OfferCustomerCISGUS": "Offer Customer CIS-GUS",
    "select.tradeTerms.option.OfferCustomerNonEU": "Offer Customer Non-EU",
    "select.tradeTerms.option.OfferCustomerTurkey1":
      "Offer Customer Turkey (up to 50 TE)",
    "select.tradeTerms.option.OfferCustomerTurkey2":
      "Offer Customer Turkey (over 50 TE)",
    "select.tradeTerms.option.Intra": "IntraGroup",
    "select.tradeTerms.option.EK": "purchase price",
    "select.tradeTerms.option.ConSensTest": "ConSens test setup",
    "select.tradeTerms.option.ABCustomerEU": "AB Customer EU",
    "select.tradeTerms.option.ABCustomerCISGUS": "AB Customer CIS-GUS",
    "select.tradeTerms.option.ABCustomerNonEU": "AB Customer Non-EU",
    "select.tradeTerms.option.ABIntra": "AB IntraGroup",
    "buttons.print.bom": "Bill of materials",
    "buttons.print.summary": "Summary",
    "accordion.summary.attachments.download": "Downloads",
    "accordion.documentGeneration.output.header": "Output",
    "tooltip.incompleteConfiguration.addToQuoteButton.disabled":
      "Please complete the configuration before adding it to a quote",
    "tooltip.incompleteConfiguration.addToCartButton.disabled":
      "Please complete the configuration before adding it to a cart",
  },
};
